import { z } from "zod";
import { locales } from "../models.js";

export default {
  params: z.object({
    email: z.email(),
    lang: z.enum(locales),
  }),
  response: z.void(),
};
